module.exports = __webpack_public_path__ + "images/a7ad818ddc272e3adf64dae561e53365.png";